import React, { useState } from "react";

const UserContext = React.createContext({
  user: {
    id: "",
    fullname: "",
    codemeli: "",
    tell: "",
    mobile: "",
    path: "",
    address: "",
  },
  isLoading: "",
  customerOrders: "",
  superAdminOrders: "",
  setUser: (state) => {},
  setIsLoading: (state) => {},
  setCustomerOrders: (state) => {},
  setSuperAdminOrders: (state) => {},
});

export default UserContext;

export const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState({
    id: "",
    fullname: "",
    codemeli: "",
    tell: "",
    mobile: "",
    path: "",
    address: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [customerOrders, setCustomerOrders] = useState(false);
  const [superAdminOrders, setSuperAdminOrders] = useState(false);
  return (
    <UserContext.Provider
      value={{
        user,
        isLoading,
        customerOrders,
        superAdminOrders,
        setUser,
        setIsLoading,
        setCustomerOrders,
        setSuperAdminOrders,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
